export const CANNY_KEY = '665458a504ce5f159e8a281c';
export const CANNY_URL = 'https://wonderslide.canny.io/feature-requests';
export const CANNY_DEFAULT_USER = {
		name: "Wonderslide's User",
		email: "wonderslide@user.com",
		id: 1,
	}